import React from 'react'
import { connect } from 'react-redux'
import { Konfettikanone } from 'react-konfettikanone'
import {
  MODAL_DONATE,
  URL_DISSENTER_SHOP,
  URL_DISSENTER_SHOP_DONATIONS
} from '../../constants'
import { expenses, isPro } from '../../initial_state'
import PanelLayout from './panel_layout'
import ProgressBar from '../progress_bar'
import Button from '../button'
import Text from '../text'
import Icon from '../icon'
import { openModal } from '../../actions/modal'

class ProgressPanel extends React.PureComponent {
  
  handleOnOpenDonateModal = () => {
    this.props.onOpenDonateModal()
  }

  render() {
    const isFunded = expenses >= 100

    const subtitle = (
      <div className={[_s.d, _s.flexRow, _s.aiCenter, _s.jcCenter].join(' ')}>
        <Text
          color="secondary"
          size="small"
          weight="bold"
          className={_s.mrAuto}
        >
          Be a free speech hero!
        </Text>
        <Button
          noClasses
          // href={URL_DISSENTER_SHOP_DONATIONS}
          onClick={this.handleOnOpenDonateModal}
          className={[
            _s.d,
            _s.flexRow,
            _s.aiCenter,
            _s.jcCenter,
            _s.outlineNone,
            _s.bgTransparent,
            _s.noUnderline
          ].join(' ')}
        >
          <Text align="center" color="brand" weight="medium" className={_s.mr5}>
            Donate
          </Text>
          <Icon id="arrow-right" className={_s.cBrand} size="14px" />
        </Button>
      </div>
    )

    return (
      <PanelLayout
        key="progress-panel"
        noPadding
        title='Help keep Gab online'
        subtitle={subtitle}
      >
        {isFunded && (
          <Konfettikanone
            launch
            colors={['#21cf7a1f', '#21cf7a3b', '#21cf7a5c', '#21cf7a80']}
            duration={50}
          />
        )}
        <div className={[_s.d, _s.px15, _s.pb15, _s.pt5].join(' ')}>
          <ProgressBar
            progress={expenses}
            title={`${expenses}% of monthly goal met`}
            // href={URL_DISSENTER_SHOP}
            onClick={this.handleOnOpenDonateModal}
          />
        </div>
        {isFunded && isPro && (
          <div className={[_s.d, _s.px15, _s.pb15].join(' ')}>
            <Text align="left" size="small" weight="medium" color="secondary">
              Thank you for being a GabPRO member!
            </Text>
          </div>
        )}
      </PanelLayout>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  onOpenDonateModal() {
    dispatch(openModal(MODAL_DONATE))
  },
})

export default connect(null, mapDispatchToProps)(ProgressPanel)